
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { requiredValidationRule } from '@/helpers/validationRules';
import { fetchGetLookupProductModel } from '@/helpers/fetchers';
import _debounce from 'lodash/debounce';
import NoDataSelectItem from '@/components/selectItems/NoDataSelectItem.vue';
import CommonSelectItem from '@/components/selectItems/CommonSelectItem.vue';

@Component({
  components: {
    NoDataSelectItem,
    CommonSelectItem,
  },
})
export default class ProductsModelComboboxField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  public debounceFetchWrapper = _debounce(this.fetchWrapper, 150);
  public search = '';
  public items: string[] = [];
  public isFetching = false;
  public isComponentJustCreated = true; // TODO toggle first search when pass the value

  get fieldValue() {
    return this.value;
  }

  set fieldValue(value) {
    this.$emit('input', value || '');
  }

  public fetchWrapper(): Promise<void> {
    const search = this.search;
    this.isFetching = true;
    return fetchGetLookupProductModel(search) // TODO promised debounce and cancel
      .then(items => {
        if (search !== this.search) {
          return;
        }
        this.items = items;
      })
      .finally(() => {
        this.isFetching = false;
      });
  }

  public getSearchString(search?: string | null) {
    return (search && search.trim()) || '';
  }

  @Watch('search')
  private watchSearch(newSearch?: string | null, oldSearch?: string | null) {
    if (newSearch === null && this.fieldValue) {
      this.fieldValue = '';
      return;
    }
    newSearch = this.getSearchString(newSearch);
    oldSearch = this.getSearchString(oldSearch);
    if (newSearch.length >= 3) {
      if (newSearch.toUpperCase() !== oldSearch.toUpperCase()) {
        this.debounceFetchWrapper();
      }
    } else {
      this.items = []; // TODO cancel
    }
  }

  public fieldValidationRules = [requiredValidationRule];
}
